type RolePermission = {
  moduleId?: number | string | null;
  permissionId?: number | string | null;
};

export enum ModuleId {
  Dashboard = 1,
  Users = 2,
  Roles = 3,
  AuditLogs = 4,
  Settings = 5,
  MasterData = 6,
  Workflow = 7,
  Weddings = 8,
  Divorces = 9,
  Reports = 10,
  Payments = 11,
}

export enum ApplicationPermissionId {
  View = 1,
  Create = 2,
  Edit = 3,
  Delete = 4,
  Approve = 5,
  Confirm = 6,
  Attest = 7,
  Query = 8,
  Reject = 9,
  Cancel = 10,
  Close = 11,
  Apply = 12,
  Print = 13,
  Reprint = 14,
}

const normalizeValue = (value: number | string | null | undefined) => {
  if (value === null || value === undefined) {
    return null;
  }
  return String(value);
};

const loadRolePermissions = (): RolePermission[] => {
  const raw = localStorage.getItem("twdc_role_permissions");
  if (!raw) {
    return [];
  }

  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const HasPermission = (
  moduleId: number | string,
  permissionId?: number | string,
) => {
  const moduleKey = normalizeValue(moduleId);
  const permissionKey = permissionId ? normalizeValue(permissionId) : null;

  return loadRolePermissions().some((entry) => {
    const entryModule = normalizeValue(entry.moduleId);
    const entryPermission = normalizeValue(entry.permissionId);

    return (
      moduleKey &&
      entryModule === moduleKey &&
      permissionKey &&
      entryPermission === permissionKey
    );
  });
};

export const HasModulePermission = (moduleId: number | string) => {
  const moduleKey = normalizeValue(moduleId);

  return loadRolePermissions().some((entry) => {
    const entryModule = normalizeValue(entry.moduleId);
    return moduleKey && entryModule === moduleKey;
  });
};

declare global {
  interface Window {
    HasPermission?: typeof HasPermission;
    HasModulePermission?: typeof HasModulePermission;
  }
}

if (typeof window !== "undefined") {
  window.HasPermission = HasPermission;
  window.HasModulePermission = HasModulePermission;
}
